module.exports = ->
  restrict: 'E'
  scope:
    areas: '='
    model: '='
  template: require('./index.pug')()
